import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Table from "../../../../../components/Table/Table";
import "./TokenHistory.css";
import searchIcon from "../../../../../assets/header/searchIcon.png";
//services
import { customer } from "../../../../../services/customer";
//utils
import { formatDate, formatTime } from "../../../../../utils/utils";

const TokenHistory = () => {
  const [tokenData, setTokenData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [balance, setBalance] = useState(0);
  const { id } = useParams();

  const fetchTokenHistory = async (page = 1) => {
    try {
      setIsLoading(true);
      const params = {
        page: page,
        items_per_page: 10,
      };
      const response = await customer.tokenHistory(id, params);
      if (response?.data?.data) {
        const movements = response.data.data.map((movement) => ({
          ...movement,
          date: formatDate(movement.created_at),
          time: formatTime(movement.created_at),
        }));
        setTokenData(movements);
        setTotalItems(response.data.total || 0);
      } else {
        setTokenData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching token history:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      const timeoutId = setTimeout(() => {
        fetchTokenHistory(currentPage);
      }, 500);

      return () => clearTimeout(timeoutId);
    }
  }, [currentPage, id]);

  useEffect(() => {
    if (id) {
      fetchTokenHistory();
      fetchBalance();
    }
  }, [id]);

  const fetchBalance = async () => {
    try {
      const response = await customer.balance(id);
      if (response.status === "success") {
        setBalance(response.data.available_tokens);
      } else {
        setBalance(0);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const columns = [
    {
      header: "Movement",
      field: "action",
      render: (row) => row.action.replace("_", " "),
    },
    {
      header: "Quantity",
      field: "tokens_obtained",
    },
    {
      header: "Date",
      field: "date",
      render: (row) => row.date,
    },
    {
      header: "Time",
      field: "time",
      render: (row) => row.time,
    },
  ];

  return (
    <div className="token-history">
      <Table
        data={tokenData}
        columns={columns}
        itemsPerPage={10}
        currentPage={currentPage}
        totalItems={totalItems}
        onPageChange={handlePageChange}
        isLoading={isLoading}
      />
      <div className="pagination-info">
        <div className="quantity-search">
          <input
            type="text"
            className="quantity-input"
            value={`Current tokens: ${balance.toLocaleString("en-US")}`}
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

export default TokenHistory;
